import { z } from 'zod';

export const eventTypeSchema = z.enum([
  'file.uploaded',
  'file.processed',
  'file.processing_failed',
  'file.deleted',
  'app.quota_threshold',
]);
export type EventType = z.infer<typeof eventTypeSchema>;
export const EVENT_TYPES = eventTypeSchema.options;

export const activityEventSchema = z.object({
  id: z.string(),
  type: eventTypeSchema,
  occurredAt: z.string(),
  appId: z.string(),
  appName: z.string(),
  fileId: z.string().nullable(),
  filePath: z.string().nullable(),
  data: z.record(z.string(), z.unknown()),
});
export type ActivityEvent = z.infer<typeof activityEventSchema>;
